/**
 * Error reports about missed environment variables
 *
 * @example
 * ```js
 * throw new ProcessEnvError('ENV_VARIABLE_NAME')
 * ```
 */
export class ProcessEnvError extends Error {
  public constructor(message: string, options?: ErrorOptions) {
    super(message, options)

    this.name = 'ProcessEnvError'
  }
}
